import { Component } from '@angular/core';

@Component({
  selector: 'app-garmin-redirect',
  templateUrl: './garmin-redirect.component.html'
})
export class GarminRedirectComponent {}
